module.exports = __webpack_public_path__ + "img/alere.89f28612.png";